import {
    CBM_WIZARD_SET_ACTIVE_STEP,
    CBM_WIZARD_SET_REPORT_TYPE,
    CBM_WIZARD_SET_REPORTING_YEAR,
    CBM_WIZARD_SET_REPORTING_PERIOD,
    CBM_WIZARD_SET_SESSION_ID,
    CBM_WIZARD_FETCH_SELECT_ITEMS_REQUEST,
    CBM_WIZARD_FETCH_SELECT_ITEMS_SUCCESS,
    CBM_WIZARD_FETCH_SELECT_ITEMS_FAILURE,
    CBM_WIZARD_SAVE_DRAFT_REQUEST,
    CBM_WIZARD_SAVE_DRAFT_SUCCESS,
    CBM_WIZARD_SAVE_DRAFT_FAILURE,
    CBM_WIZARD_EXTRACTION_TRIGGER_REQUEST,
    CBM_WIZARD_EXTRACTION_TRIGGER_SUCCESS,
    CBM_WIZARD_EXTRACTION_TRIGGER_FAILURE,
    CBM_WIZARD_EXTRACTION_STATUS_REQUEST,
    CBM_WIZARD_EXTRACTION_STATUS_SUCCESS,
    CBM_WIZARD_EXTRACTION_STATUS_FAILURE,
    CBM_WIZARD_EXTRACT_RECORDS_REQUEST,
    CBM_WIZARD_EXTRACT_RECORDS_SUCCESS,
    CBM_WIZARD_EXTRACT_RECORDS_FAILURE,
    CBM_WIZARD_EXTRACT_LAYOUT_REQUEST,
    CBM_WIZARD_EXTRACT_LAYOUT_SUCCESS,
    CBM_WIZARD_EXTRACT_LAYOUT_FAILURE,
    CBM_WIZARD_SET_EXTRACT_PAGE,
    CBM_WIZARD_SET_EXTRACT_PAGE_SIZE,
    CBM_WIZARD_SET_EXTRACT_SEARCH,
    CBM_WIZARD_SET_EXTRACT_SORT,
    CBM_WIZARD_EXPORT_CSV_REQUEST,
    CBM_WIZARD_EXPORT_CSV_SUCCESS,
    CBM_WIZARD_EXPORT_CSV_FAILURE,
    CBM_WIZARD_EXPORT_PRECHECK_REPORT_REQUEST,
    CBM_WIZARD_EXPORT_PRECHECK_REPORT_SUCCESS,
    CBM_WIZARD_EXPORT_PRECHECK_REPORT_FAILURE,
    CBM_WIZARD_VALIDATION_TRIGGER_REQUEST,
    CBM_WIZARD_VALIDATION_TRIGGER_SUCCESS,
    CBM_WIZARD_VALIDATION_TRIGGER_FAILURE,
    CBM_WIZARD_VALIDATION_STATUS_REQUEST,
    CBM_WIZARD_VALIDATION_STATUS_SUCCESS,
    CBM_WIZARD_VALIDATION_STATUS_FAILURE,
    CBM_WIZARD_VALIDATION_RESULTS_REQUEST,
    CBM_WIZARD_VALIDATION_RESULTS_SUCCESS,
    CBM_WIZARD_VALIDATION_RESULTS_FAILURE,
    CBM_WIZARD_SET_VALIDATION_SEVERITY_FILTER,
    CBM_WIZARD_SET_VALIDATION_REPORT_FILTER,
    CBM_WIZARD_SET_VALIDATION_RULE_FILTER,
    CBM_WIZARD_SET_VALIDATION_FIELD_FILTER,
    CBM_WIZARD_EXPORT_VALIDATION_ERRORS_REQUEST,
    CBM_WIZARD_EXPORT_VALIDATION_ERRORS_SUCCESS,
    CBM_WIZARD_EXPORT_VALIDATION_ERRORS_FAILURE,
    CBM_WIZARD_EXPORT_SUMMARY_REQUEST,
    CBM_WIZARD_EXPORT_SUMMARY_SUCCESS,
    CBM_WIZARD_EXPORT_SUMMARY_FAILURE,
    CBM_WIZARD_TRIGGER_EXPORT_REQUEST,
    CBM_WIZARD_TRIGGER_EXPORT_SUCCESS,
    CBM_WIZARD_TRIGGER_EXPORT_FAILURE,
    CBM_WIZARD_EXPORT_STATUS_REQUEST,
    CBM_WIZARD_EXPORT_STATUS_SUCCESS,
    CBM_WIZARD_EXPORT_STATUS_FAILURE,
    CBM_WIZARD_DOWNLOAD_EXPORT_REQUEST,
    CBM_WIZARD_DOWNLOAD_EXPORT_SUCCESS,
    CBM_WIZARD_DOWNLOAD_EXPORT_FAILURE,
    CBM_WIZARD_DOWNLOAD_MANIFEST_REQUEST,
    CBM_WIZARD_DOWNLOAD_MANIFEST_SUCCESS,
    CBM_WIZARD_DOWNLOAD_MANIFEST_FAILURE,
    CBM_WIZARD_RESET,
    CBM_WIZARD_HYDRATE_SESSION,
    CBM_WIZARD_FETCH_TERMS_REQUEST,
    CBM_WIZARD_FETCH_TERMS_SUCCESS,
    CBM_WIZARD_FETCH_TERMS_FAILURE,
    CBM_WIZARD_SET_TERM,
    SET_RCS_P1_FIELD,
    SET_RCS_P1_PREFILL,
    SET_RCS_EXTRACTED,
    RCS_VALIDATION_LOADING,
    RCS_VALIDATION_LOADED
} from './cbmWizardTypes';

const initialState = {
    activeStep: 1,
    furthestStep: 1,
    sessionId: null,
    reportType: null,
    reportingYear: null,
    reportingPeriod: null,
    reportTypes: [],
    reportingYears: [],
    reportingPeriods: [],
    institution: null,
    terms: {
        items: [],
        loading: false
    },
    selectedTermId: null,
    isLoading: false,
    isSaving: false,
    error: null,
    extraction: {
        status: null,
        recordCount: null,
        startTime: null,
        endTime: null,
        errorMessage: null,
        isLoading: false,
        precheckFlaggedCount: 0,
        precheckCleanCount: 0,
        precheckFieldBreakdown: [],
    },
    extractRecords: {
        records: [],
        totalCount: 0,
        pageNumber: 1,
        pageSize: 50,
        searchTerm: '',
        sortColumn: '',
        sortAscending: true,
        reportType: '',
        reportingYear: '',
        reportingPeriod: '',
        dataSources: [],
        isLoading: false,
    },
    fieldLayout: {
        columns: [],
        isLoading: false,
    },
    csvExporting: false,
    precheckReportExporting: false,
    validation: {
        triggering: false,
        status: null,
        errorCount: 0,
        warningCount: 0,
        totalRows: 0,
        results: [],
        eligibleRecords: [],
        loading: false,
        error: null,
        severityFilter: '',
        reportFilter: '',
        ruleFilter: '',
        fieldFilter: '',
        exporting: false,
    },
    export: {
        summary: null,
        summaryLoading: false,
        summaryError: null,
        triggering: false,
        triggerError: null,
        status: null,
        statusLoading: false,
        downloading: false,
        downloadError: null,
        manifestDownloading: false,
    },
    rcsP1: {
        officialName: '', officialTitle: '', officialEmail: '',
        catalogUrl: '', websiteUrl: '', certified: false,
        submissionDate: '2025-08-15', prefilled: false,
    },
    rcsP2Extracted: false,
    rcsValidation: { rows: 0, errors: [], warnings: [], cleanCount: 0, cleanPct: '', loading: false, loaded: false },
};

const cbmWizardReducer = (state = initialState, action) => {
    switch (action.type) {
        case CBM_WIZARD_SET_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.payload,
                furthestStep: Math.max(state.furthestStep, action.payload)
            };

        case CBM_WIZARD_FETCH_TERMS_REQUEST:
            return {
                ...state,
                terms: { ...state.terms, loading: true }
            };

        case CBM_WIZARD_FETCH_TERMS_SUCCESS:
            return {
                ...state,
                terms: { items: action.payload, loading: false }
            };

        case CBM_WIZARD_FETCH_TERMS_FAILURE:
            return {
                ...state,
                terms: { ...state.terms, loading: false }
            };

        case CBM_WIZARD_SET_TERM:
            return {
                ...state,
                selectedTermId: action.payload
            };

        case CBM_WIZARD_HYDRATE_SESSION:
            return {
                ...state,
                sessionId: action.payload.id,
                reportType: action.payload.reportType,
                reportingYear: action.payload.reportingYear,
                reportingPeriod: action.payload.reportingPeriod,
                activeStep: action.payload.currentStep || 1,
                furthestStep: Math.max(state.furthestStep, action.payload.currentStep || 1)
            };

        case CBM_WIZARD_SET_REPORT_TYPE:
            return {
                ...state,
                reportType: action.payload
            };

        case CBM_WIZARD_SET_REPORTING_YEAR:
            return {
                ...state,
                reportingYear: action.payload
            };

        case CBM_WIZARD_SET_REPORTING_PERIOD:
            return {
                ...state,
                reportingPeriod: action.payload
            };

        case CBM_WIZARD_SET_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload
            };

        case CBM_WIZARD_FETCH_SELECT_ITEMS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case CBM_WIZARD_FETCH_SELECT_ITEMS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                reportTypes: action.payload.reportTypes || [],
                reportingYears: action.payload.reportingYears || [],
                reportingPeriods: action.payload.reportingPeriods || [],
                institution: action.payload.institution || null
            };

        case CBM_WIZARD_FETCH_SELECT_ITEMS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: 'Failed to load select items'
            };

        case CBM_WIZARD_SAVE_DRAFT_REQUEST:
            return {
                ...state,
                isSaving: true,
                error: null
            };

        case CBM_WIZARD_SAVE_DRAFT_SUCCESS:
            return {
                ...state,
                isSaving: false,
                sessionId: action.payload?.id || state.sessionId
            };

        case CBM_WIZARD_SAVE_DRAFT_FAILURE:
            return {
                ...state,
                isSaving: false,
                error: 'Failed to save draft'
            };

        case CBM_WIZARD_EXTRACTION_TRIGGER_REQUEST:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: true,
                    status: 'Pending',
                    errorMessage: null
                }
            };

        case CBM_WIZARD_EXTRACTION_TRIGGER_SUCCESS:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: false,
                    precheckFlaggedCount: action.payload?.precheckFlaggedCount || 0,
                    precheckCleanCount: action.payload?.precheckCleanCount || 0,
                    precheckFieldBreakdown: action.payload?.precheckFieldBreakdown || []
                }
            };

        case CBM_WIZARD_EXTRACTION_TRIGGER_FAILURE:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: false,
                    errorMessage: 'Failed to start extraction'
                }
            };

        case CBM_WIZARD_EXTRACTION_STATUS_REQUEST:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: true
                }
            };

        case CBM_WIZARD_EXTRACTION_STATUS_SUCCESS:
            return {
                ...state,
                extraction: {
                    status: action.payload?.extractionStatus || null,
                    recordCount: action.payload?.recordCount || 0,
                    startTime: action.payload?.startTime || null,
                    endTime: action.payload?.endTime || null,
                    errorMessage: action.payload?.errorMessage || null,
                    isLoading: false,
                    precheckFlaggedCount: action.payload?.precheckFlaggedCount || 0,
                    precheckCleanCount: action.payload?.precheckCleanCount || 0,
                    precheckFieldBreakdown: action.payload?.precheckFieldBreakdown || []
                }
            };

        case CBM_WIZARD_EXTRACTION_STATUS_FAILURE:
            return {
                ...state,
                extraction: {
                    ...state.extraction,
                    isLoading: false,
                    errorMessage: 'Failed to fetch extraction status'
                }
            };

        case CBM_WIZARD_EXTRACT_RECORDS_REQUEST:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    isLoading: true
                }
            };

        case CBM_WIZARD_EXTRACT_RECORDS_SUCCESS:
            return {
                ...state,
                extractRecords: {
                    records: action.payload?.records || [],
                    totalCount: action.payload?.totalCount || 0,
                    pageNumber: action.payload?.pageNumber || 1,
                    pageSize: action.payload?.pageSize || 50,
                    searchTerm: action.payload?.searchTerm || '',
                    reportType: action.payload?.reportType || '',
                    reportingYear: action.payload?.reportingYear || '',
                    reportingPeriod: action.payload?.reportingPeriod || '',
                    dataSources: action.payload?.dataSources || [],
                    isLoading: false,
                    sortColumn: state.extractRecords.sortColumn,
                    sortAscending: state.extractRecords.sortAscending
                }
            };

        case CBM_WIZARD_EXTRACT_RECORDS_FAILURE:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    isLoading: false
                }
            };

        case CBM_WIZARD_EXTRACT_LAYOUT_REQUEST:
            return {
                ...state,
                fieldLayout: {
                    ...state.fieldLayout,
                    isLoading: true
                }
            };

        case CBM_WIZARD_EXTRACT_LAYOUT_SUCCESS:
            return {
                ...state,
                fieldLayout: {
                    columns: action.payload || [],
                    isLoading: false
                }
            };

        case CBM_WIZARD_EXTRACT_LAYOUT_FAILURE:
            return {
                ...state,
                fieldLayout: {
                    ...state.fieldLayout,
                    isLoading: false
                }
            };

        case CBM_WIZARD_SET_EXTRACT_PAGE:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    pageNumber: action.payload
                }
            };

        case CBM_WIZARD_SET_EXTRACT_PAGE_SIZE:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    pageSize: action.payload,
                    pageNumber: 1
                }
            };

        case CBM_WIZARD_SET_EXTRACT_SEARCH:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    searchTerm: action.payload,
                    pageNumber: 1
                }
            };

        case CBM_WIZARD_SET_EXTRACT_SORT:
            return {
                ...state,
                extractRecords: {
                    ...state.extractRecords,
                    sortColumn: action.payload.sortColumn,
                    sortAscending: action.payload.sortAscending,
                    pageNumber: 1
                }
            };

        case CBM_WIZARD_EXPORT_CSV_REQUEST:
            return {
                ...state,
                csvExporting: true
            };

        case CBM_WIZARD_EXPORT_CSV_SUCCESS:
            return {
                ...state,
                csvExporting: false
            };

        case CBM_WIZARD_EXPORT_CSV_FAILURE:
            return {
                ...state,
                csvExporting: false
            };

        case CBM_WIZARD_EXPORT_PRECHECK_REPORT_REQUEST:
            return {
                ...state,
                precheckReportExporting: true
            };

        case CBM_WIZARD_EXPORT_PRECHECK_REPORT_SUCCESS:
            return {
                ...state,
                precheckReportExporting: false
            };

        case CBM_WIZARD_EXPORT_PRECHECK_REPORT_FAILURE:
            return {
                ...state,
                precheckReportExporting: false
            };

        case CBM_WIZARD_VALIDATION_TRIGGER_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    triggering: true,
                    error: null
                }
            };

        case CBM_WIZARD_VALIDATION_TRIGGER_SUCCESS:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    triggering: false,
                    status: 'Pending'
                }
            };

        case CBM_WIZARD_VALIDATION_TRIGGER_FAILURE:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    triggering: false,
                    error: 'Failed to trigger validation'
                }
            };

        case CBM_WIZARD_VALIDATION_STATUS_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    loading: true
                }
            };

        case CBM_WIZARD_VALIDATION_STATUS_SUCCESS:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    status: action.payload?.validationStatus || null,
                    errorCount: action.payload?.errorCount || 0,
                    warningCount: action.payload?.warningCount || 0,
                    totalRows: action.payload?.totalRows || 0,
                    loading: false,
                    error: null
                }
            };

        case CBM_WIZARD_VALIDATION_STATUS_FAILURE:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    loading: false,
                    error: 'Failed to fetch validation status'
                }
            };

        case CBM_WIZARD_VALIDATION_RESULTS_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    loading: true
                }
            };

        case CBM_WIZARD_VALIDATION_RESULTS_SUCCESS:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    results: action.payload?.results || [],
                    eligibleRecords: action.payload?.eligibleRecords || [],
                    errorCount: action.payload?.totalErrors ?? state.validation.errorCount,
                    warningCount: action.payload?.totalWarnings ?? state.validation.warningCount,
                    totalRows: action.payload?.totalRows ?? state.validation.totalRows,
                    loading: false,
                    error: null
                }
            };

        case CBM_WIZARD_VALIDATION_RESULTS_FAILURE:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    loading: false,
                    error: 'Failed to fetch validation results'
                }
            };

        case CBM_WIZARD_SET_VALIDATION_SEVERITY_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    severityFilter: action.payload
                }
            };

        case CBM_WIZARD_SET_VALIDATION_REPORT_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    reportFilter: action.payload
                }
            };

        case CBM_WIZARD_SET_VALIDATION_RULE_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    ruleFilter: action.payload
                }
            };

        case CBM_WIZARD_SET_VALIDATION_FIELD_FILTER:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    fieldFilter: action.payload
                }
            };

        case CBM_WIZARD_EXPORT_VALIDATION_ERRORS_REQUEST:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    exporting: true
                }
            };

        case CBM_WIZARD_EXPORT_VALIDATION_ERRORS_SUCCESS:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    exporting: false
                }
            };

        case CBM_WIZARD_EXPORT_VALIDATION_ERRORS_FAILURE:
            return {
                ...state,
                validation: {
                    ...state.validation,
                    exporting: false
                }
            };

        case CBM_WIZARD_EXPORT_SUMMARY_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    summaryLoading: true,
                    summaryError: null
                }
            };

        case CBM_WIZARD_EXPORT_SUMMARY_SUCCESS:
            return {
                ...state,
                export: {
                    ...state.export,
                    summary: action.payload,
                    summaryLoading: false,
                    summaryError: null
                }
            };

        case CBM_WIZARD_EXPORT_SUMMARY_FAILURE:
            return {
                ...state,
                export: {
                    ...state.export,
                    summaryLoading: false,
                    summaryError: action.payload || 'Failed to load export summary'
                }
            };

        case CBM_WIZARD_TRIGGER_EXPORT_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    triggering: true,
                    triggerError: null,
                    status: 'Pending'
                }
            };

        case CBM_WIZARD_TRIGGER_EXPORT_SUCCESS:
            return {
                ...state,
                export: {
                    ...state.export,
                    triggering: false,
                    status: action.payload?.exportStatus || 'Pending'
                }
            };

        case CBM_WIZARD_TRIGGER_EXPORT_FAILURE:
            return {
                ...state,
                export: {
                    ...state.export,
                    triggering: false,
                    triggerError: action.payload || 'Failed to trigger export',
                    status: 'Failed'
                }
            };

        case CBM_WIZARD_EXPORT_STATUS_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    statusLoading: true
                }
            };

        case CBM_WIZARD_EXPORT_STATUS_SUCCESS:
            return {
                ...state,
                export: {
                    ...state.export,
                    status: action.payload?.exportStatus || null,
                    statusLoading: false,
                    summary: state.export.summary ? {
                        ...state.export.summary,
                        fileName: action.payload?.fileName ?? state.export.summary.fileName,
                        expiresAt: action.payload?.expiresAt ?? state.export.summary.expiresAt,
                        totalRecordCount: action.payload?.recordCount ?? state.export.summary.totalRecordCount
                    } : null,
                    triggerError: action.payload?.exportStatus === 'Failed'
                        ? action.payload?.errorMessage || 'Export failed'
                        : state.export.triggerError
                }
            };

        case CBM_WIZARD_EXPORT_STATUS_FAILURE:
            return {
                ...state,
                export: {
                    ...state.export,
                    statusLoading: false
                }
            };

        case CBM_WIZARD_DOWNLOAD_EXPORT_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    downloading: true,
                    downloadError: null
                }
            };

        case CBM_WIZARD_DOWNLOAD_EXPORT_SUCCESS:
            return {
                ...state,
                export: {
                    ...state.export,
                    downloading: false,
                    downloadError: null
                }
            };

        case CBM_WIZARD_DOWNLOAD_EXPORT_FAILURE:
            return {
                ...state,
                export: {
                    ...state.export,
                    downloading: false,
                    downloadError: action.payload || 'Failed to download extract file'
                }
            };

        case CBM_WIZARD_DOWNLOAD_MANIFEST_REQUEST:
            return {
                ...state,
                export: {
                    ...state.export,
                    manifestDownloading: true
                }
            };

        case CBM_WIZARD_DOWNLOAD_MANIFEST_SUCCESS:
            return {
                ...state,
                export: {
                    ...state.export,
                    manifestDownloading: false
                }
            };

        case CBM_WIZARD_DOWNLOAD_MANIFEST_FAILURE:
            return {
                ...state,
                export: {
                    ...state.export,
                    manifestDownloading: false
                }
            };

        case SET_RCS_P1_FIELD:
            return { ...state, rcsP1: { ...state.rcsP1, [action.payload.key]: action.payload.value } };

        case SET_RCS_P1_PREFILL:
            return { ...state, rcsP1: { ...state.rcsP1, ...action.payload, prefilled: true } };

        case SET_RCS_EXTRACTED:
            return { ...state, rcsP2Extracted: action.payload };

        case RCS_VALIDATION_LOADING:
            return { ...state, rcsValidation: { ...state.rcsValidation, loading: true } };

        case RCS_VALIDATION_LOADED:
            return { ...state, rcsValidation: { ...action.payload, loading: false, loaded: true } };

        case CBM_WIZARD_RESET:
            // Reference lookups survive a reset — only wizard/session state clears.
            // rcsP1/rcsP2Extracted/rcsValidation reset automatically via ...initialState spread.
            return {
                ...initialState,
                reportTypes: state.reportTypes,
                reportingYears: state.reportingYears,
                reportingPeriods: state.reportingPeriods,
                institution: state.institution
            };

        default:
            return state;
    }
};

export default cbmWizardReducer;
